import React from 'react';
import { Box } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import { CustomButton } from 'shared/ui/CustomButton';

interface FFDActionButtonsProps {
  addParameter: () => void;
  removeParameter: () => void;
  resetValues: () => void;
  sendable: boolean;
}

export const FFDActionButtons: React.FC<FFDActionButtonsProps> = ({
  addParameter,
  removeParameter,
  resetValues,
  sendable,
}) => (
  <>
    <Box component="div" sx={{ width: '100%' }}>
      <CustomButton
        size="small"
        disabled={!sendable}
        onClick={addParameter}
        startIcon={<AddIcon />}
        variant="contained"
        sx={{ fontSize: '10px', width: '100%' }}
      >
        Add
      </CustomButton>
    </Box>

    <Box component="div" sx={{ width: '100%' }}>
      <CustomButton
        size="small"
        onClick={removeParameter}
        startIcon={<RemoveIcon />}
        variant="contained"
        sx={{ fontSize: '10px', width: '100%' }}
      >
        Remove
      </CustomButton>
    </Box>

    <Box component="div" sx={{ width: '100%' }}>
      <CustomButton
        size='small'
        onClick={resetValues}
        startIcon={<RestartAltIcon />}
        variant='contained'
        sx={{ fontSize: '10px', width: '100%' }}
      >
        Clear
      </CustomButton>
    </Box>
  </>
);
